module.exports = __webpack_public_path__ + "static/media/img_Characterdesign-Senior-02Secornd_S02.7905b17a.png";